// Detecta o erro que o navegador/Vite lança quando um `import()` dinâmico
// (rota lazy-loaded) falha porque o arquivo do chunk não existe mais no
// servidor — típico de uma aba que ficou aberta durante um novo deploy,
// que substitui os arquivos com hash antigo por uma nova build.
export const CHUNK_LOAD_ERROR_PATTERN = /failed to fetch dynamically imported module|loading chunk .* failed|error loading dynamically imported module/i;

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return CHUNK_LOAD_ERROR_PATTERN.test(error.message);
}
